var _filter, _circle, _ellipse, _circle2, _circle3, _circle4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg10N(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "moon10n",
    cx: "40%",
    cy: "30%",
    r: "40%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#E2E8F0",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#94A3B8",
      stopOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heavyRainClouds10n",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#475569",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#334155",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "heavyRainShadow10n"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 4,
    stdDeviation: 3,
    floodColor: "#1E293B",
    floodOpacity: 0.6
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 5,
    fill: "url(#moon10n)",
    opacity: 0.6
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 35,
    rx: 22,
    ry: 14,
    fill: "url(#heavyRainClouds10n)",
    filter: "url(#heavyRainShadow10n)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30,
    r: 11,
    fill: "url(#heavyRainClouds10n)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 30,
    r: 13,
    fill: "url(#heavyRainClouds10n)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 25,
    r: 9,
    fill: "url(#heavyRainClouds10n)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1E40AF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 52,
    x2: 34,
    y2: 72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 55,
    x2: 44,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57,
    y1: 53,
    x2: 54,
    y2: 73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: 56,
    x2: 64,
    y2: 76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 58,
    x2: 39,
    y2: 78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 61,
    x2: 49,
    y2: 81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 59,
    x2: 59,
    y2: 79
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10N);
export default __webpack_public_path__ + "static/media/10n.4025b882d169501ae28b38642c5441d9.svg";
export { ForwardRef as ReactComponent };